"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var Table =
/*#__PURE__*/
(0, _styled.default)("table", {
  target: "e1vdo5380"
})({
  borderCollapse: 'collapse'
});
Table.displayName = 'Table';
var _default = Table;
exports.default = _default;